var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('k-card-header',{attrs:{"items":_vm.items,"title":_vm.title}}),_c('client-detail',{attrs:{"can-write":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }